//this is the best place to initialize all backward compatibility stuff
//this is entrypoit for all vue projects
import '#public/commons-global';

import Vue, {
    type AsyncComponent,
    type Component,
    h,
} from 'vue';
import Fragment from 'vue-fragment';

// eslint-disable-next-line import/prefer-default-export
export function createApp(mainComponent: Component | AsyncComponent, el = '#app') {
    Vue.use(Fragment.Plugin);
    const app = new Vue({
        el,
        components: { App: mainComponent },
        render() {
            return h('App');
        },
    });
    return app;
}
